import React, { useEffect, useState } from 'react';
import styles from '../../../../styles/materialPDF.module.css';
import { Form, Button } from 'react-bootstrap';
import axios from '../../../../constents/axios';
import { useNavigate } from 'react-router-dom';
import { S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";

const ORACLE_STORAGE_URL = process.env.REACT_APP_ORACLE_STORAGE_URL;
const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

const AddNewPDF = () => {
  const [materialData, setMaterialData] = useState({});
  const [caption, setCaption] = useState('');
  const [link, setLink] = useState('');
  const [file, setFile] = useState(null);
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');
  const [publishDemo, setPublishDemo] = useState(null);
  const [subject, setSubject] = useState('');
  const [project, setProject] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const { courseName, currentTopicName, currentSubTopicName } = materialData;

  const handleAddNewPDF = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    let uploadedUrl = await uploadToS3();
    if (!uploadedUrl) {
      setIsSubmitting(false);
      return;
    }
    setLink(uploadedUrl);
    try {
      await axios.post(`/add-newpdf`, {
        sl_no: "0",
        course_id: `${courseName}`,
        topics: `${currentTopicName}`,
        subtopic: `${currentSubTopicName}`,
        caption: `${caption}`,
        description: `${description}`,
        materialLink: `${uploadedUrl}`,
        is_free: publishDemo,
        date: `${date}`
      }, {
        headers: {
          'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa`,
        }
      });

      navigate(`/studentJourney/${courseName}`);
    } catch (error) {
      console.error('Error adding topic:', error);
    }
    setIsSubmitting(false);
  };

  const uploadToS3 = async () => {
    if (!file) {
      setMessage({ type: "error", text: "Please select a PDF file." });
      return null;
    }

    const fileName = `${Date.now()}-${file.name}`;
    const folderPath = `learning_materials/uploads/materials/${project}/${subject}/`;
    const key = `${folderPath}${fileName}`;

    // ⚠️ WARNING: Do NOT expose credentials like this in production
    const s3Client = new S3Client({
      region: process.env.REACT_APP_AWS_REGION, // your region
      credentials: {
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
      },
    });

    try {
      const parallelUploads3 = new Upload({
        client: s3Client,
        params: {
          Bucket: process.env.REACT_APP_AWS_S3_BUCKET,
          Key: key,
          Body: file,
          ContentType: file.type,
        },
      });

      await parallelUploads3.done();

      const s3Url = key.replace(/^learning_materials\//, '');
      return s3Url;
    } catch (error) {
      console.error("Upload error:", error);
      setMessage({ type: "error", text: "Upload failed. Please try again." });
      return null;
    }
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFile = e.dataTransfer.files[0];
      if (droppedFile.type !== "application/pdf") {
        alert("Only PDF files are allowed.");
        return;
      }
      setFile(droppedFile);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile?.type === "application/pdf") {
      setFile(selectedFile);
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  const handleChangeCaption = (e) => setCaption(e.target.value);
  const handleChangeDate = (e) => setDate(e.target.value);
  const handleChangePublishDemo = (e) => setPublishDemo(e.target.value === "1" ? 1 : 0);

  useEffect(() => {
    const fetchData = async () => {
      const storedMaterialData = JSON.parse(localStorage.getItem('materialData'));
      if (storedMaterialData) {
        setMaterialData(storedMaterialData);

        try {
          const response = await axios.get(`/getCourseDetails/${storedMaterialData.courseName}`, {
            headers: {
              'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa`,
            }
          });
          console.log("response", response.data.data[0]);
          setProject(response.data.data[0].project === "" ? "null" : response.data.data[0].project);
          setSubject(response.data.data[0].subject);
        } catch (error) {
          console.error("Error fetching course details:", error);
        }
      }
    };

    fetchData();
  }, []);

  return (
    <div className={styles.addPdf}>
      <div className={styles.mainHeadDiv}>
        <div className="row">
          <div className="col-md-3">
            <div className={styles.header}>
              <strong>Course Name:</strong>
            </div>
            <div className={styles.header}>
              <strong>Topic Name:</strong>
            </div>
            <div className={styles.header}>
              <strong>SubTopic Name:</strong>
            </div>
          </div>
          <div className="col-md-4">
            <div className={styles.header}>
              <span>{courseName}</span>
            </div>
            <div className={styles.header}>
              <span>{currentTopicName}</span>
            </div>
            <div className={styles.header}>
              <span>{currentSubTopicName}</span>
            </div>
          </div>
        </div>
        <h3 className={styles.mainHead}>CREATE PDF MATERIAL</h3>
        <form onSubmit={handleAddNewPDF}>
          <div className="row">
            <div className="col-md-6">
              <div className={styles.inputDiv}>
                <label>
                  <strong>Material Caption</strong>
                </label>
                <Form.Control
                  type="text"
                  placeholder="Give a Caption"
                  required
                  onChange={handleChangeCaption}
                  className={styles.input}
                />
              </div>
              <div className={styles.inputDiv}>
                <label>
                  <strong>Description</strong>
                </label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div
                className={`${styles.inputDiv} ${styles.dropZone} ${dragActive ? styles.active : ""
                  }`}
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleFileDrop}
              >
                <label>
                  <strong>Material File</strong>
                </label>
                <p>Drag & Drop PDF here or click to select</p>
                <Form.Control
                  type="file"
                  accept="application/pdf"
                  onChange={handleFileChange}
                  className={styles.input}
                />
              </div>
              {file && (
                <div className={styles.fileName}>
                  📄 <strong>Selected File:</strong> {file.name}
                </div>
              )}
            </div>
            <div className="col-md-6">
              <div className={styles.inputDiv}>
                <label>
                  <strong>Date</strong>
                </label>
                <Form.Control
                  type="date"
                  required
                  onChange={handleChangeDate}
                  className={styles.input}
                />
              </div>
              <div className={styles.inputDiv}>
                <label>
                  <strong>Do you want to publish as demo?</strong>
                </label>
                <div className={styles.checkDiv}>
                  <Form.Check
                    type="radio"
                    name="publishDemo"
                    label="Yes"
                    value="1"
                    onChange={handleChangePublishDemo}
                    required
                  />
                  <Form.Check
                    type="radio"
                    name="publishDemo"
                    label="No"
                    value="0"
                    onChange={handleChangePublishDemo}
                    required
                  />
                </div>
              </div>
            </div>
            <div className={styles.saveBtnDiv}>
              <Button
                className={styles.saveBtn}
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Uploading..." : "Save"}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNewPDF;
